// import { Link } from "react-router-dom";s
function About() {
	return (
		<section className="desktopMaxWidth aboutSection">
			<div className="vision">
				<div className="visionTextContainer">
					<p className="tag visionCardTag">Mission</p>
					<p className="visionText">Fostering Healing Through Compassion</p>
				</div>
				{/* <Link to="/about" className="aboutLink">
					<button aria-label="Learn More" className="cta ctaSecondary ctaThird">
						Learn More
					</button>
				</Link> */}
			</div>
			<div className="approachContainer">
				{/* <div className="approach">
					<div className="approachTitleContainer">
						<i className="fa-solid fa-square-check"></i>
						<p>Patient-Centered Care</p>
					</div>
					<p>
						Prioritizing your unique needs and strengths, guiding you toward
						meaningful growth and resilience.
					</p>
				</div>
				<div className="approach">
					<div className="approachTitleContainer">
						<i className="fa-solid fa-square-check"></i>
						<p>Evidence-Based Solutions</p>
					</div>
					<p>
						Proven methods like CBT and Motivational Interviewing to address
						life’s challenges effectively.
					</p>
				</div>
				<div className="approach">
					<div className="approachTitleContainer">
						<i className="fa-solid fa-square-check"></i>
						<p>Holistic Well-Being</p>
					</div>
					<p>
						Supporting your journey to mental, emotional, and relational
						wellness through compassionate, culturally sensitive care.
					</p>
				</div> */}
				<div className="approach">
					<p>
						Our mission is to provide you with the highest quality service in a
						non-judgmental setting that promotes your ability to identify and
						resolve problems by learning skills that will help you heal.
					</p>
					<p>
						We are passionate about the work we do and approach our work in a
						warm and professional manner utilizing research-based approaches to
						support you resolve problems by understanding yourself more.
					</p>
				</div>
			</div>
			<div className="vision">
				<div className="visionTextContainer">
					<p className="tag visionCardTag">Vision</p>
					<p className="visionText">
						Empowering Minds, Strengthening Lives: A Vision for Holistic
						Well-Being
					</p>
				</div>
				{/* <Link to="/about" className="aboutLink">
					<button aria-label="Learn More" className="cta ctaSecondary ctaThird">
						Learn More
					</button>
				</Link> */}
			</div>
			<div className="approachContainer">
				<div className="approach">
					<p>
						Our goal is to provide culturally competent, holistic, and wellness
						focused services that promote people’s social and emotional
						strength, prevent development of mental health challenges, and
						address current problems.
					</p>
					<p>
						This will be done by teaching people skills and providing them with
						resources needed to overcome obstacles.
					</p>
				</div>
			</div>
		</section>
	);
}

export default About;
